import { render, staticRenderFns } from "./BannerSettingsTab.vue?vue&type=template&id=57ce1f97&scoped=true&"
import script from "./BannerSettingsTab.vue?vue&type=script&lang=js&"
export * from "./BannerSettingsTab.vue?vue&type=script&lang=js&"
import style0 from "./BannerSettingsTab.vue?vue&type=style&index=0&id=57ce1f97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ce1f97",
  null
  
)

export default component.exports